module.exports = __webpack_public_path__ + "img/edujournal.88f4418a.png";